import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import Lottie from 'react-lottie';
import styled from 'styled-components';
import { Controller, Scene } from 'react-scrollmagic';
import animationData from '../../../public/animations/use-cases.json';
import { useWindowSize } from '@react-hook/window-size/throttled';
import smoothscroll from 'smoothscroll-polyfill';
import { isMobileOnly } from 'react-device-detect';

export const UseCasesAnimation: FunctionComponent = () => {
  const [, windowHeight] = useWindowSize();
  const animation = useRef<any>(null);

  const [positionY, setPositionY] = useState(0);
  const [offset, setOffset] = useState(0);

  function setupClickListeners() {
    const ids = ['Connect', 'Discover', 'Build', 'Deploy'];
    const element = animation.current.el;

    ids.map((id, idx) => {
      const heading = element.querySelector(`g[aria-label="${id}"]`);

      heading.setAttribute('class', 'clickable');
      heading.addEventListener('click', () => {
        setSelectedIndex(idx);
      });
    });
  }

  function setSelectedIndex(index: number) {
    const scroll = (top: number) =>
      window?.document?.documentElement?.scrollTo({
        top: positionY + top,
        behavior: 'smooth',
      });

    switch (index) {
      case 0:
        return scroll(0);

      case 1:
        return scroll(300);

      case 2:
        return scroll(650);

      case 3:
        return scroll(1000);
    }
  }

  function setAnimationProgress(progress: number) {
    const percentage = parseInt(
      (animation.current?.anim?.totalFrames * progress).toFixed()
    );

    animation.current?.anim.goToAndStop(percentage, true);
  }

  useEffect(() => {
    smoothscroll.polyfill();
    setOffset(windowHeight * 0.495);
  }, [windowHeight]);

  if (isMobileOnly) {
    return null;
  }

  return (
    <>
      <Controller vertical={true} refreshInterval={1}>
        <Scene duration={1000} pin={true} offset={offset} classToggle="visible">
          {(p: number) => {
            setAnimationProgress(p);

            return (
              <Container
                id="animation"
                ref={(ref) => {
                  const { top } = ref?.getBoundingClientRect() ?? {};

                  if (top && !positionY) {
                    setPositionY(top);
                  }
                }}
              >
                <Lottie
                  ref={animation}
                  isClickToPauseDisabled={true}
                  isPaused={true}
                  options={{
                    autoplay: false,
                    loop: false,
                    animationData,
                    rendererSettings: {
                      preserveAspectRatio: 'xMinYMin slice',
                      filterSize: {
                        width: '200%',
                        height: '200%',
                        x: '-50%',
                        y: '-50%',
                      },
                    } as any,
                  }}
                  eventListeners={[
                    {
                      eventName: 'DOMLoaded',
                      callback: () => setupClickListeners(),
                    },
                  ]}
                />
              </Container>
            );
          }}
        </Scene>
      </Controller>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  inset: auto !important;
  top: 0% !important;

  .clickable {
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
  }
`;
